import { render, staticRenderFns } from "./WikiKeywordReadOnly.vue?vue&type=template&id=88a43680&scoped=true&"
import script from "./WikiKeywordReadOnly.vue?vue&type=script&lang=js&"
export * from "./WikiKeywordReadOnly.vue?vue&type=script&lang=js&"
import style0 from "./WikiKeywordReadOnly.vue?vue&type=style&index=0&id=88a43680&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a43680",
  null
  
)

export default component.exports